"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectTemplateListSchema = exports.createProjectTemplateInputSchema = exports.projectTemplateSchema = void 0;
const zod_1 = require("zod");
const project_1 = require("./project");
exports.projectTemplateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    orgId: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    createdBy: zod_1.z.string(),
    deletedAt: zod_1.z.string().optional(),
    objectives: zod_1.z.array(zod_1.z.string()),
    outline: project_1.projectOutlineSchema,
    tasks: zod_1.z.array(project_1.projectTaskSchema),
});
exports.createProjectTemplateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, "Template name is required"),
    description: zod_1.z.string().min(1, "Template description is required"),
    projectId: zod_1.z.string().min(1, "Project ID is required"),
});
exports.projectTemplateListSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    createdAt: zod_1.z.string(),
});
